import type { RouteRecordRaw } from "vue-router";

export const surveysRoutes: RouteRecordRaw[] = [
  {
    path: "/surveys/info",
    name: "surveys-info",
    component: () => import("./info/SurveyInfoPage.vue"),
    meta: {
      namespace: "surveys",
      title: "tools_meta.surveys_prefix",
    },
  },
  {
    path: "/surveys/surveys",
    name: "surveys-index",
    component: () => import("./surveys/SurveyListPage.vue"),
    meta: {
      requiresAuth: true,
      namespace: "surveys",
      title: "tools_meta.surveys_prefix",
    },
  },
  // Parent layout - passes item prop to children via RouterView
  {
    path: "/surveys/surveys/:id",
    name: "surveys-show",
    component: () => import("./surveys/SurveyLayout.vue"),
    meta: {
      requiresAuth: true,
      namespace: "surveys",
      title: "tools_meta.surveys_prefix",
    },
    children: [
      {
        path: "settings",
        name: "surveys-settings",
        component: () => import("./surveys/[id]/settings.vue"),
        meta: {
          requiresAuth: true,
          namespace: "surveys",
          title: "tools_meta.surveys_prefix",
        },
      },
      {
        path: "share",
        name: "surveys-share",
        component: () => import("./surveys/[id]/share.vue"),
        meta: {
          requiresAuth: true,
          namespace: "surveys",
          title: "tools_meta.surveys_prefix",
        },
      },
    ],
  },
  // Dot-notation routes (not children of the show layout)
  {
    path: "/surveys/surveys/:id/public_survey_responses/:responseId",
    name: "survey-responses-public-show",
    component: () =>
      import("./surveys.[id].public_survey_responses/[responseId]/PublicSurveyResponseDetailPage.vue"),
    meta: {
      namespace: "surveys",
      title: "tools_meta.surveys_prefix",
    },
  },
  {
    path: "/surveys/surveys/:id/public_survey_responses/new",
    name: "survey-responses-public-new",
    component: () =>
      import("./surveys.[id].public_survey_responses/new/PublicSurveyResponseNewPage.vue"),
    meta: {
      namespace: "surveys",
      title: "tools_meta.surveys_prefix",
    },
  },
  {
    path: "/surveys/surveys/:id/public_survey_result",
    name: "survey-responses-public-result-index",
    component: () =>
      import("./surveys.[id].public_survey_result/PublicSurveyResultPage.vue"),
    meta: {
      namespace: "surveys",
      title: "tools_meta.surveys_prefix",
    },
  },
  {
    path: "/surveys/surveys/:id/public_survey_result/responses/:responsePage",
    name: "survey-responses-public-result-show",
    component: () =>
      import("./surveys.[id].public_survey_result/responses/[responsePage]/PublicSurveyResultResponsePage.vue"),
    meta: {
      namespace: "surveys",
      title: "tools_meta.surveys_prefix",
    },
  },
  {
    path: "/surveys/surveys/:id/responses",
    name: "surveys-responses-index",
    component: () =>
      import("./surveys.[id].responses/SurveyResponseListPage.vue"),
    meta: {
      namespace: "surveys",
      title: "tools_meta.surveys_prefix",
    },
  },
  {
    path: "/surveys/surveys/:id/responses/:responsePage",
    name: "surveys-responses-show",
    component: () =>
      import("./surveys.[id].responses/[responsePage]/SurveyResponsePageDetailPage.vue"),
    meta: {
      namespace: "surveys",
      title: "tools_meta.surveys_prefix",
    },
  },
];
